export default "__VITE_ASSET__gAIYjPmL__"